import * as React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'reactstrap';
import { formatMessage } from 'src/api';

import { ValidationItem } from 'franke-trough-dependencies';

import MESSAGES from '../Error/Error.messages';

import './Icon.scss';
import { FormattedMessage } from 'react-intl';

export interface IconErrorWithToolTipProps {
  error?: (false | ValidationItem)[];
  id: string;
  inline?: boolean;
}

export interface IconErrorWithToolTipState {
  tooltipOpen: boolean;
}

export class IconErrorWithToolTip extends React.Component<IconErrorWithToolTipProps, IconErrorWithToolTipState> {
  constructor(props: IconErrorWithToolTipProps) {
    super(props);    
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false
    };
  }

  public render() {
    const triggerId = `tooltip_${this.props.id}`;
    return (
      <>
        <div
          className={classNames(
            'icon-tool-tip', 
            'icon-tool-tip-error', {
            'inline-block': this.props.inline
          })}
          id={triggerId}
        >
          !
        </div>
        <Tooltip placement="top" isOpen={this.state.tooltipOpen} target={triggerId} toggle={this.toggle}>
          {this.errorMessages && this.errorMessages.length > 0 ? this.errorMessages.map((error, index) => {
            const key = `error_${this.props.id}_${index}`;
            return (
              <p key={key}>
                {error ? error : (
                  <FormattedMessage {...MESSAGES.default} />
                )}
              </p>
            );
          }) : (
            <FormattedMessage {...MESSAGES.default} />
          )}
        </Tooltip>
      </>
    );
  }

  private get errorMessages(): (string | null)[] {
    const errors: (string | null)[] = [];
    if (this.props.error) {
      this.props.error.map(error => MESSAGES[this.props.id] && error && errors.push(formatMessage(MESSAGES[this.props.id]) || null));
    }
    return errors;
  }
  
  private toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }
}

export default IconErrorWithToolTip;
